import {GET_CATEGORY_LIST} from "../action_types";

export const getCategoryList = () => {
    return {
        type: GET_CATEGORY_LIST,
        api: true,
    }
};